import { Separator } from '@talentmesh/ui/components/separator';
import { cn } from '@talentmesh/ui/lib/utils';

interface ToolbarSeparatorProps {
    className?: string;
}

const ToolbarSeparator = ({ className }: ToolbarSeparatorProps) => {
    return <Separator orientation="vertical" className={cn('h-5 w-px data-vertical:self-center', className)} />;
};

export default ToolbarSeparator;
